var _a;
import { LogLevel } from "typescript-logging";
import { CategoryProvider } from "typescript-logging-category-style";
import { Log } from "./models";
const levels = {
    debug: "debug",
    info: "info",
    warn: "warn",
    error: "error",
    fatal: "fatal",
};
var _logger;
const _currentLevel = (_a = process.env.REACT_APP_LOG_LEVEL) !== null && _a !== void 0 ? _a : levels.info;
function configure() {
    const applicationName = process.env.REACT_APP_NAME;
    if (applicationName === undefined || applicationName === null)
        throw new Error("Application name can't be null!");
    CategoryProvider.clear();
    const provider = CategoryProvider.createProvider("LoggerProvider", {
        level: LogLevel.toLogLevel(_currentLevel),
    });
    const defaultCategory = provider.getCategory(applicationName);
    _logger = new Log(defaultCategory, applicationName);
}
/**
 * Get status of logging
 *
 * @returns 0 -> Not ready | 1 -> Able to logging local | 2 -> Able to logging on server
 */
function getStatus() {
    const applicationName = process.env.REACT_APP_NAME;
    const user = process.env.REACT_APP_LOG_USER;
    const password = process.env.REACT_APP_LOG_PASSWORD;
    const server = process.env.REACT_APP_LOG_SERVER;
    let status = 0;
    if (applicationName !== undefined && applicationName !== null)
        status = 1;
    if (status == 1 &&
        user !== undefined &&
        user !== null &&
        password !== undefined &&
        password !== null &&
        server !== undefined &&
        server !== null)
        status = 2;
    return status;
}
function debug(message, args) {
    if (getStatus() > 0)
        _logger.debug(message, args);
}
function info(message, args) {
    if (getStatus() > 0)
        _logger.info(message, args);
}
function warn(message, args) {
    if (getStatus() > 0)
        _logger.warn(message, args);
}
function error(message, args) {
    if (getStatus() > 0)
        _logger.error(message, args);
}
function fatal(message, args) {
    if (getStatus() > 0)
        _logger.fatal(message, args);
}
export const logger = {
    currentLevel: _currentLevel,
    levels,
    getStatus,
    configure,
    debug,
    info,
    warn,
    error,
    fatal,
};
